'use client';

import Image from 'next/image';
import type { ReactNode } from 'react';

import { WavyBackground } from '@/components/ui/wavy-background';
import { WAVY_BACKGROUND_COLORS } from '@/constants/ui/wavy-background';

type AuthLayoutProps = {
  children: ReactNode;
  showWavyBackground?: boolean;
};

export function AuthLayout({
  children,
  showWavyBackground = true,
}: AuthLayoutProps) {
  return (
    <div className="grid h-screen lg:grid-cols-2 overflow-hidden" style={{ backgroundColor: 'hsl(0, 0%, 98.04%)' }}>
      <div className="flex flex-col justify-center px-6 md:px-10 lg:px-16 overflow-y-auto" style={{ backgroundColor: 'hsl(0, 0%, 98.04%)' }}>
        <div className="mx-auto w-full max-w-sm space-y-6">
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <Image
              src="/images/logos/logo.svg"
              alt="how.fm"
              width={180}
              height={60}
              priority
            />
          </div>

          {/* Form Content */}
          <div className="space-y-4">
            {children}
          </div>
        </div>
      </div>

      {/* Right side with wavy background */}
      {showWavyBackground === true && (
        <div className="relative hidden lg:block h-screen overflow-hidden" style={{ backgroundColor: 'hsl(0, 0%, 98.04%)' }}>
          <WavyBackground
            containerClassName="h-full w-full"
            className="h-full w-full flex items-center justify-center"
            colors={[...WAVY_BACKGROUND_COLORS]}
            backgroundFill="hsl(0, 0%, 98.04%)"
            blur={12}
            speed="slow"
            waveOpacity={0.25}
            waveWidth={80}
          >
            {/* Content is displayed through the wavy background effect */}
          </WavyBackground>
        </div>
      )}
    </div>
  );
}
